module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-header-layout unselectable"
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "bs-b"
  }, [_c('DesktopHeader', {
    attrs: {
      "nav-state": _vm.navState
    }
  }), _vm._v(" "), _vm._t("desktop-subheader")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_vm._t("layout-body")], 2), _vm._v(" "), _vm._t("modal-area")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-629a544c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoHeaderLayout.vue
// module id = 1583
// module chunks = 1